<template>
  <Card :id="careType" :clickable="true" class="m-8 care-type-card-item w-160 md:w-240 lg:w-160" @click="handleSelect">
    <div class="card-type-card-content">
      <component :is="careTypeDetails[careType].icon" class="mb-8" />
      <span class="mb-8">{{ careTypeDetails[careType].title }}</span>
      <Spinner v-if="selected" />
      <Arrow v-else />
    </div>
  </Card>
</template>

<script lang="ts">
import Card from '../card/Card.vue';
import Arrow from '../../icons/Arrow.vue';
import Spinner from '../spinner/Spinner.vue';

import ChildCareIcon from '../../icons/BabysitterIcon.vue';
import NannyIcon from '../../icons/NannyIcon.vue';
import HousekeepingIcon from '../../icons/HousekeepingIcon.vue';
import PetCareIcon from '../../icons/DashboardPetCareIcon.vue';
import CompanionCareIcon from '../../icons/CompanionCareIcon.vue';
import DisabilityCareIcon from '../../icons/SpecialNeedsCareIcon.vue';

export default {
  name: 'PoppinsCareTypeCard',
  components: {
    Card,
    Arrow,
    Spinner,
  },
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    careType: {
      type: String,
      required: true,
    },
  },
  computed: {
    careTypeDetails() {
      return {
        CHILD_CARE: {
          icon: ChildCareIcon,
          title: 'Child Care',
        },
        BABYSITTER: {
          icon: ChildCareIcon,
          title: 'Babysitter',
        },
        NANNY: {
          icon: NannyIcon,
          title: 'Nanny',
        },
        HOUSEKEEPING: {
          icon: HousekeepingIcon,
          title: 'Housekeeper',
        },
        PET_CARE: {
          icon: PetCareIcon,
          title: 'Pet care',
        },
        SPECIAL_NEEDS: {
          icon: DisabilityCareIcon,
          title: 'Disabilities care',
        },
        COMPANION_CARE: {
          icon: CompanionCareIcon,
          title: 'Care Companion',
        },
      };
    },
  },
  methods: {
    handleSelect() {
      this.$emit('click', this.careType);
    },
  },
};
</script>

<style lang="scss" scoped>
.care-type-card-item {
  .card-type-card-content {
    align-items: center;
    background: #fff;
    padding: 1.5rem 0.5rem 1rem 0.5rem;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    text-align: center;
    height: 152px;
    width: 100%;
  }
}
</style>
